export default __webpack_public_path__ + "static/media/sec5boxes.999821ca.svg";